<template>
  <v-app>
    <Def>
      <v-container fluid style="margin-top:100px;">
        <v-row>
          <v-col cols="2" class="pa-0">
            <Bt :token="$store.state.polz" :toggle_exclusive="4" />
          </v-col>
          <v-col cols="7" class="ml-12">
            <v-card
              class="rounded-lg pa-3"
              outlined
              height="50em"
              style="border: 2px #5B98F1 solid"
            >
              <v-card
                outlined
                color="white"
                height="5em"
                class="mt-2"
                v-for="n in items"
                :key="n.Name"
                @click="go(n.id)"
              >
                <v-list-item>
                  <v-list-item-avatar size="45" color="grey lighten-1"></v-list-item-avatar>
                  <v-list-item-content>
                    <v-col class="pa-0">
                      <v-row class="ma-0">
                        <v-col class="pa-0 headline">
                          {{n.Name}}
                          <v-avatar v-if="n.Pols == 'Pred'" class="ml-3" color="orange" size="20"></v-avatar>
                          <v-avatar v-if="n.Pols == 'BYZ'" class="ml-3" color="green" size="20"></v-avatar>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-list-item-subtitle class="pt-2">{{n.Message}}</v-list-item-subtitle>
                        <v-list-item-subtitle class="text-right black--text mt-n8">{{n.Data}}</v-list-item-subtitle>
                      </v-row>
                    </v-col>
                  </v-list-item-content>
                </v-list-item>
                <v-col class="pa-0"></v-col>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="2" class="pt-0 pl-12 ml-8">
            <Bt2 />
          </v-col>
        </v-row>
      </v-container>
    </Def>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        id: 1,
        Name: "Хайруллина Фарида",
        Pols: "Stud",
        Message:
          "вот такой макс длиной и в одну строчку будет наше сообщение здесь когда-нибудь возможно будет тут строка",
        Data: "10:47",
      },
      {
        id: 2,
        Name: "Татнефть",
        Pols: "Pred",
        Message:
          "вот такой макс длиной и в одну строчку будет наше сообщение здесь когда-нибудь возможно будет тут строка",
        Data: "21.07.2020",
      },
      {
        id: 3,
        Name: "КГЭУ",
        Pols: "BYZ",
        Message:
          "вот такой макс длиной и в одну строчку будет наше сообщение здесь когда-нибудь возможно будет тут строка",
        Data: "21.07.2020",
      },
    ],
  }),
  methods: {
    go(e) {
      this.$router.push("/Messagen/" + String(e));
    },
  },
  created(){
    if(this.$ls.get("inAk") == undefined){
      this.$router.replace("/")
    }
  }
};
</script>